<script setup lang="ts">
const multiplierY = 0.5

const gavelStyles = useScrollTransformedStyle({
  multiplierX: -0.25,
  multiplierY: 0.45,
  rotateMultiplier: 0.03,
})

const bookBigBlueStyles = useScrollTransformedStyle({
  multiplierX: -0,
  multiplierY,
  rotateMultiplier: -0.08,
})

const bookDarkBlueStyles = useScrollTransformedStyle({
  multiplierX: 0,
  multiplierY,
  rotateMultiplier: -0.05,
})

const bookSmallBlueStyles = useScrollTransformedStyle({
  multiplierX: 0.15,
  multiplierY,
  rotateMultiplier: -0.1,
})
</script>

<template>
  <svg class="w-80" width="400" height="400" viewBox="0 0 400 400" overflow="visible" fill="none" xmlns="http://www.w3.org/2000/svg">

    <g :style="gavelStyles">
      <path d="M120.635 160.688L195.385 180.55C197.607 181.14 198.934 183.427 198.344 185.65C197.753 187.872 195.466 189.199 193.244 188.608L118.494 168.747L120.635 160.688Z" fill="#CFFDFF" stroke="#CFFDFF" stroke-width="0.283946" stroke-miterlimit="10" />
      <path d="M76.4593 188.743C84.1052 188.743 90.3034 177.202 90.3034 162.966C90.3034 148.73 84.1052 137.189 76.4593 137.189C68.8134 137.189 62.6152 148.73 62.6152 162.966C62.6152 177.202 68.8134 188.743 76.4593 188.743Z" fill="#DAFEA4" />
      <path d="M84.9289 137.189H76.459V188.736H84.9289V137.189Z" fill="#DAFEA4" />
      <path d="M84.9281 188.743C92.5739 188.743 98.7722 177.202 98.7722 162.966C98.7722 148.73 92.5739 137.189 84.9281 137.189C77.2822 137.189 71.084 148.73 71.084 162.966C71.084 177.202 77.2822 188.743 84.9281 188.743Z" fill="#102B09" />
      <path d="M88.6976 182.773C94.7179 182.773 99.5984 173.905 99.5984 162.966C99.5984 152.027 94.7179 143.159 88.6976 143.159C82.6773 143.159 77.7969 152.027 77.7969 162.966C77.7969 173.905 82.6773 182.773 88.6976 182.773Z" fill="#DAFEA4" />
      <path d="M135.153 182.773C141.173 182.773 146.053 173.905 146.053 162.966C146.053 152.027 141.173 143.159 135.153 143.159C129.132 143.159 124.252 152.027 124.252 162.966C124.252 173.905 129.132 182.773 135.153 182.773Z" fill="#F8F8F8" />
      <path d="M135.154 143.159H88.6973V182.773H135.154V143.159Z" fill="#DAFEA4" />
      <path d="M140.001 137.189H131.531V188.736H140.001V137.189Z" fill="#DAFEA4" />
      <path opacity="0.2" d="M122.673 143.159L93.7871 182.773H122.673V143.159Z" fill="#102B09" />
      <path d="M131.532 188.743C139.177 188.743 145.376 177.202 145.376 162.966C145.376 148.73 139.177 137.189 131.532 137.189C123.886 137.189 117.688 148.73 117.688 162.966C117.688 177.202 123.886 188.743 131.532 188.743Z" fill="#DAFEA4" />
      <path d="M140 188.743C147.646 188.743 153.844 177.202 153.844 162.966C153.844 148.73 147.646 137.189 140 137.189C132.354 137.189 126.156 148.73 126.156 162.966C126.156 177.202 132.354 188.743 140 188.743Z" fill="#102B09" />
    </g>

    <g :style="bookBigBlueStyles">
      <path d="M141.232 188.736H236.707C254.478 188.736 268.897 203.162 268.897 220.926V228.177C268.897 245.948 254.471 260.366 236.707 260.366H141.232V188.729V188.736Z" fill="#A3B5FE" />
      <path d="M129.17 188.736H186.132C200.697 188.736 212.525 200.565 212.525 215.129V233.981C212.525 248.545 200.697 260.374 186.132 260.374H129.17V188.736Z" fill="#A3B5FE" />
      <path d="M60.0742 195.018H132.148C148.451 195.018 161.685 208.252 161.685 224.555C161.685 240.858 148.451 254.092 132.148 254.092H60.0742V195.011V195.018Z" fill="#F8F8F8" />
      <path d="M161.351 188.736H56V195.018H161.351V188.736Z" fill="#A3B5FE" />
      <path d="M161.351 254.099H56V260.38H161.351V254.099Z" fill="#A3B5FE" />
      <path d="M67.4707 208.938H99.792" stroke="#160926" stroke-miterlimit="10" />
      <path d="M92.6855 218.003H151.601" stroke="#160926" stroke-miterlimit="10" />
      <path d="M124.431 218.003C124.016 218.003 123.379 218.723 123.136 218.979C122.229 219.956 121.786 221.237 121.536 222.525C121.259 223.972 121.135 225.448 120.885 226.895C120.789 227.477 120.602 228.065 120.366 228.606C120.248 228.876 120.11 229.139 119.951 229.381C119.867 229.513 119.798 229.672 119.396 230.053C120.913 229.901 125.526 226.569 125.526 226.569L129.432 230.053C129.522 230.136 130.193 229.035 130.249 228.945C130.664 228.252 130.879 227.567 131.045 226.77C131.378 225.212 131.495 223.619 131.814 222.061C132.084 220.752 132.43 219.298 133.476 218.377C133.67 218.21 133.885 218.065 134.127 217.989C134.127 217.989 124.424 217.989 124.417 217.989L124.431 218.003Z" fill="#160926" />
    </g>

    <g :style="bookDarkBlueStyles">
      <path d="M221.906 274.875L295.317 258.946L274.083 125H219.808L199.654 129.495L221.906 274.875Z" fill="#00173B" />
      <path d="M240.571 270.38L219.482 125" stroke="#7F8CFA" stroke-width="0.858763" stroke-miterlimit="10" />
    </g>

    <g :style="bookSmallBlueStyles">
      <path d="M326.938 152.384L344.487 261.371L285.24 270.381L268.127 152.384H326.938Z" fill="#A3B5FE" />
      <path d="M268.126 152.384L285.239 270.381H267.523L252.377 156.103L268.126 152.384Z" fill="#A3B5FE" />
      <path d="M285.24 270.381L268.127 152.384" stroke="#7F8CFA" stroke-width="0.858763" stroke-miterlimit="10" />
    </g>
  </svg>
</template>
